
class CapViewBuilding {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_building'
}

function create(config) {
  return new CapViewBuilding(config)
}

export default {
  key,
  create,
}
